<template>
    <b-container fluid>
        <Loading :active.sync="Loading"></Loading>
        
        <div class="d-flex align-items-center">
            <h2>Preprensa</h2>
            <b-button 
                @click="exportExcel()" 
                variant="outline-success" 
                class="mr-3 ml-3"
            >
            Descargar
            </b-button>
        </div>
        <List :items="historico" :fields="fields" :urls="urls" :comentarios="comentarios" />
    </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters} from 'vuex'
    import XLSX from 'xlsx'
    //importacion local
    import List from '@/components/preprensa/Historico'

    export default {
        name:'historicoPreprensa',
        components:{
            Loading, List
        },
        mounted(){
            this.init()
        },
        data:function () {
            return{
                fields:[
                    {key: 'id',label:'Folio',sortable:true},
                    {key: 'orden',label:'Prioridad',sortable:true},
                    {key: 'cliente', label:'Cliente',sortable:true},
                    {key:'acciones', label:'Acciones'},
                    {key:'producto', lable:'Producto',sortable:true},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'trabajo', label:'Trabajo', sortable:true},
                    {key:'otro', label:'otro'},
                    {key:'fecha', label:'Fecha', sortable:true},
                    {key:'hora', label:'Hora'},
                    {key:'solicitante', label:'Solicitante', sortable:true},
                    {key:'url', label:'Link de archivo'},
                    {key:'observaciones',label:'Observaciones'},
                    {key:'comentario_ingenieria', label:'Observaciones Ingenieria'},
                    {key:'status',label:'Estado', sortable:true, variant: 'primary'},
                    {key:'preprensa',label:'Comentario de preprensa'},
                    {key:'ingenieria',label:'Comentario de ingenieria'},
                    {key:'create_at',label:'Creación'},
                    {key:'update_at',label:'Ultima Actualización'},
                    
                    ]
            }            
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('preprensa',['historico','csv']),
            ...mapState('urls',['urls']),
            ...mapState('comentarioIng',['comentarios'])
        },
        methods:{
            ...mapActions({
                _fetchHistorico: 'preprensa/fetchHistorico',
                _fetchUrls: 'urls/fetchUrls',
                _comentarios: 'comentarioIng/fetchComentarios',
                _csv: 'preprensa/fetchCSV'
            }),
            init(){
                this._fetchHistorico()
                this._fetchUrls()  
                this._comentarios() 
                this._csv()
            },
            /**
             * metodo que exporta la tabla a excel
             */
            exportExcel(){
                let data = XLSX.utils.json_to_sheet(this.csv)
		        const workbook = XLSX.utils.book_new()
		        const filename = 'preprensa'
		        XLSX.utils.book_append_sheet(workbook, data, filename)
		        XLSX.writeFile(workbook, `${filename}.xlsx`)
            },
        }
        
    }
</script>

<style lang="scss" scoped>

</style>